module.exports = __webpack_public_path__ + "media/images/bg-bitcoin-282fb2e3029aed055773cab08b7d8b0f.jpg";